module.exports = __webpack_public_path__ + "img/paragraph.3b0c2fcc.svg";